import { Typography, type TypographyOwnProps } from "@mui/material";

type TGradientTypographyProps = TypographyOwnProps & {
  gradient: string;
  fallbackColor: string;
};

export const GradientTypography = ({
  gradient,
  fallbackColor,
  sx,
  children,
  ...props
}: TGradientTypographyProps) => {
  return (
    <Typography
      {...props}
      sx={{
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundColor: fallbackColor,
        backgroundImage: gradient,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};
